// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__zftD1","text":"style_text__k92YC","actions":"style_actions__AZzZI","actions_btn":"style_actions_btn__jFN2g"};